import Router from './router';

const App = () => (
  <>
    <Router />
  </>
);
export default App;

